import { render, staticRenderFns } from "./CreateBotPage.vue?vue&type=template&id=78617c56&scoped=true"
import script from "./CreateBotPage.vue?vue&type=script&lang=js"
export * from "./CreateBotPage.vue?vue&type=script&lang=js"
import style0 from "./CreateBotPage.vue?vue&type=style&index=0&id=78617c56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78617c56",
  null
  
)

export default component.exports